import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
interface AccordionProps {
  title: string;
  children: React.ReactNode;
}
export function Accordion({
  title,
  children
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className={`border rounded-2xl bg-white overflow-hidden transition-colors duration-200 ease-out ${isOpen ? 'border-clinical-deep/30' : 'border-clinical-line'}`} data-id="element-201" data-mp="2oa14jhzdb60z">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-5 md:px-6 py-4 md:py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-202" data-mp="3gz6yxarvo43v">
        <span className="font-semibold text-clinical-deep pr-4 text-sm md:text-base" data-id="element-203" data-mp="3368wj4h0pbqt">
          {title}
        </span>
        <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-[transform,background-color,border-color,color] duration-200 ease-out border ${isOpen ? 'bg-clinical-deep border-clinical-deep text-white rotate-45' : 'border-clinical-line text-clinical-mid'}`} data-id="element-204" data-mp="3uzhp0bld5enz">
          <Plus className="w-3.5 h-3.5" strokeWidth={2.5} data-id="element-205" data-mp="2wyyks9nbwbbs" />
        </div>
      </button>

      <AnimatePresence data-id="element-206" data-mp="3bnl56prtbt9v">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-207" data-mp="3boe7nejqnwm7">
            <div className="px-5 md:px-6 pb-5 pt-1 border-t border-clinical-line" data-id="element-208" data-mp="3ujl4kln4dz3h">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}